import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AdminLayout } from "../Admin/AdminLayout";
import { AdminMarketplace } from "../Admin/Dashboard/AdminMarketplace";
import { SubscriberInfo } from "./SubscriberInfo";
import { PaymentInfo } from "./PaymentInfo";

export function Subscriber({ idToken, username, onSignOut }) {
    const location = useLocation();
    const [activeSection, setActiveSection] = useState("marketplace");

    // Handle query params for payment tab redirect
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const tab = queryParams.get('tab');
        if (tab === 'payment') {
            setActiveSection("payment");
        }
    }, [location.search]);

    const renderSection = () => {
        switch (activeSection) {
            case 'marketplace':
                return <AdminMarketplace idToken={idToken} isAdmin={false} />;
            case 'purchased':
                return <AdminMarketplace key="purchased" idToken={idToken} isAdmin={false} purchased />;
            case 'company':
                return <SubscriberInfo idToken={idToken} username={username} />;
            case 'payment':
                return <PaymentInfo idToken={idToken} username={username} />;
            default:
                return <AdminMarketplace idToken={idToken} isAdmin={false} />;
        }
    };

    return (
        <AdminLayout
            activeSection={activeSection}
            onSectionChange={setActiveSection}
            isAdmin={false}
            username={username}
            onSignOut={onSignOut}
        >
            {renderSection()}
        </AdminLayout>
    );
}
